import CustomButton from "components/CustomButton/CustomButton";
import ClearIcon from "icons/ClearIcon";
import SearchIcon from "icons/SearchIcon";
import { FilterActionsRow } from "../../styles";

const FilterButtons = ({ filters, applyFilters }) => {
	const isCleared = filters.isCleared();
	return (
		<FilterActionsRow>
			<CustomButton
				width="104px"
				size="small"
				icon={<SearchIcon />}
				text="Buscar"
				onClick={applyFilters}
			/>
			<CustomButton
				width="104px"
				size="small"
				variant={isCleared ? "primary" : "secondary"}
				disabled={isCleared}
				icon={<ClearIcon />}
				text="Limpiar"
				onClick={() => {
					const clearedFilters = filters.clear();
					applyFilters(clearedFilters);
				}}
			/>
		</FilterActionsRow>
	);
};

export default FilterButtons;
